import { Accordion, Stack, Text } from '@chakra-ui/react';
import type { SanityProduct } from 'types/cms/SanityProduct';

import { BundleLineItem } from './BundleLineItem';

interface BundleItem {
  product: SanityProduct;
  isFree: boolean;
  variantGid?: string;
}

interface ProductBundlesProps {
  items: BundleItem[];
}

export function ProductBundles({ items }: ProductBundlesProps) {
  return (
    <Stack gap="3xs" className="section--product-bundles">
      <Text as="h2" size="detail" fontWeight="medium">
        What's included
      </Text>
      <Accordion allowToggle>
        {items.map((item, i) => (
          <BundleLineItem
            key={item.product.slug}
            product={item.product}
            isFree={item.isFree}
            variantGid={item.variantGid}
            isLast={i === items.length - 1}
          />
        ))}
      </Accordion>
    </Stack>
  );
}
